module.exports = __webpack_public_path__ + "img/customGameBtn.97a2bfe2.png";